export class Consumer {

    id: String;
    name: String;

    constructor() {

    }
}
